module.exports = __webpack_public_path__ + "static/media/filter_icon.0ac50913.svg";